import Auth from '@/helpers/authorizations'
import ManagementLayout from '@/layouts/Management'

const userStatisticsRouter = {
  path: '/user_statistics',
  component: ManagementLayout,
  redirect: '/user_statistics/time_group_statistics',
  children: [
    {
      path: 'overview',
      component: () => import('@/views/users_analysis/Index.vue'),
      meta: {
        auth: Auth.showUserStatistics
      }
    },
    {
      path: 'topup_statistics',
      component: () => import('@/views/users/TopupStatistics'),
      meta: {
        auth: Auth.showUserStatistics
      }
    },
    {
      path: 'order_statistics',
      component: () => import('@/views/users/OrderStatistics'),
      meta: {
        auth: Auth.showUserStatistics
      }
    },
    {
      path: 'time_group_statistics',
      component: () => import('@/views/user_statistics/TimeGroupStatistics'),
      meta: {
        auth: Auth.showUserStatistics
      }
    },
    {
      path: 'prop_group_statistics',
      component: () => import('@/views/user_statistics/PropGroupStatistics'),
      meta: {
        auth: Auth.showUserStatistics
      }
    }
  ]
}
export default userStatisticsRouter
